module.exports = __webpack_public_path__ + "static/img/app-logo.7c6f5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/app-logo.png
// module id = 919
// module chunks = 0